import { render } from "./PromotionBlock.vue?vue&type=template&id=69c45939&scoped=true"
import script from "./PromotionBlock.vue?vue&type=script&lang=js"
export * from "./PromotionBlock.vue?vue&type=script&lang=js"

import "./PromotionBlock.vue?vue&type=style&index=0&id=69c45939&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c45939"]])

export default __exports__